module.exports = __webpack_public_path__ + "media/images/sp/stores/fukuoka/fukuoka_sns_01-fb732e691e43b630a3061a7e3351af89.jpg";